// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WlvV","title":"styles_title__1mH_X"};